// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getSystemColor } from "@pace/XDL/Utilities";
// eslint-disable-next-line spire/fenced-imports
import { QRCodeSVG } from "qrcode.react";
import React, { FC } from "react";

export interface ProductBarcodeProps {
    productList: CartLineModel[];
}

type Props = ProductBarcodeProps;

export interface ProductBarcodeStyle {
    wrapper?: InjectableCss;
    description?: TypographyPresentationProps;
    productInfoWrapper?: InjectableCss;
}

const ProductBarcode: FC<Props> = ({ productList }: Props) => {
    return (
        <>
            {productList.map(product => (
                <>
                    <StyledWrapper
                        style={{
                            display: "inline-flex",
                            position: "relative",
                            flexDirection: "column",
                            width: " 2.5in",
                            height: "1.5in",
                            overflow: "hidden",
                            marginRight: "15px",
                            marginBottom: "15px",
                            border: `1px solid ${getSystemColor("common.border")}`,
                            padding: "15px",
                        }}
                    >
                        <StyledWrapper
                            style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <QRCodeSVG
                                value={`${window.location.origin}${product.productUri}`}
                                height={80}
                                width={80}
                                style={{ display: "inline-block", float: "left" }}
                            />
                            <img width="80" height="80" src={product.smallImagePath} alt={product.altText} />
                        </StyledWrapper>

                        <StyledWrapper
                            style={{
                                display: "block",
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                style={{
                                    width: "100%",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    display: "block",
                                    fontSize: "14px",
                                }}
                            >
                                {product.shortDescription}
                            </Typography>
                            {product.manufacturerItem && (
                                <Typography
                                    style={{
                                        width: "100%",
                                        overflow: "hidden",
                                        display: "block",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        fontSize: "14px",
                                    }}
                                >
                                    <Typography as="b">{translate("MFR #")}</Typography> {product.manufacturerItem}
                                </Typography>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </>
            ))}
        </>
    );
};

export default ProductBarcode;
